import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "6ba521dc-d3ec-4bea-8e13-7ae33a0ebe22"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter6ba521dcD3ec4bea8e137ae33a0ebe22(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter6ba521dcD3ec4bea8e137ae33a0ebe22 footer`}>
      {props["links"] || <Navigation className="LinksBf9d9bc004444b97Ab97F31260590f04" parentTag={buildClassName("LinksBf9d9bc004444b97Ab97F31260590f04", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo81f3bf4b6e8740a091b278b262b30ff2" parentTag={buildClassName("Logo81f3bf4b6e8740a091b278b262b30ff2", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287" parentTag={buildClassName("Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow31bd02c9B2524a61Aa6a47232a79af85" parentTag={buildClassName("Groupflow31bd02c9B2524a61Aa6a47232a79af85", parentTag)} {...props} />}
    </footer>
  );
}

// id: "81f3bf4b-6e87-40a0-91b2-78b262b30ff2"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "6ba521dc-d3ec-4bea-8e13-7ae33a0ebe22"
export function Logo81f3bf4b6e8740a091b278b262b30ff2(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo81f3bf4b6e8740a091b278b262b30ff2" parentTag={buildClassName("Logo81f3bf4b6e8740a091b278b262b30ff2", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "5c29d1aa-4dde-4bc7-a1ff-c7c3a8326287"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "6ba521dc-d3ec-4bea-8e13-7ae33a0ebe22"
export function Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287" parentTag={buildClassName("Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287", parentTag)} {...props} />
  );
}

// id: "bf9d9bc0-0444-4b97-ab97-f31260590f04"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "6ba521dc-d3ec-4bea-8e13-7ae33a0ebe22"
export function LinksBf9d9bc004444b97Ab97F31260590f04(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksBf9d9bc004444b97Ab97F31260590f04" parentTag={buildClassName("LinksBf9d9bc004444b97Ab97F31260590f04", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "31bd02c9-b252-4a61-aa6a-47232a79af85"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "6ba521dc-d3ec-4bea-8e13-7ae33a0ebe22"
export function Groupflow31bd02c9B2524a61Aa6a47232a79af85(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow31bd02c9B2524a61Aa6a47232a79af85" parentTag={buildClassName("Groupflow31bd02c9B2524a61Aa6a47232a79af85", parentTag)} {...props} />
  );
}

// id: "a96c992b-9230-40a7-94dc-aa427d859c82"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "81f3bf4b-6e87-40a0-91b2-78b262b30ff2"
export const LogoTypeA96c992b923040a794dcAa427d859c82 = "FOOTER";

// id: "1c4a219f-d9de-4421-a2ab-f7c3699452db"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "bf9d9bc0-0444-4b97-ab97-f31260590f04"
export const NavMenuSlug1c4a219fD9de4421A2abF7c3699452db = "footer-nav";

// id: "dbe1e13a-4f02-4768-b2cd-d83edfcf8b0d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "81f3bf4b-6e87-40a0-91b2-78b262b30ff2"
export const ContentSlugDbe1e13a4f024768B2cdD83edfcf8b0d = "footer-logo";

const Components = {
  DefaultFooter6ba521dcD3ec4bea8e137ae33a0ebe22,
  Logo81f3bf4b6e8740a091b278b262b30ff2,
  Copyright5c29d1aa4dde4bc7A1ffC7c3a8326287,
  LinksBf9d9bc004444b97Ab97F31260590f04,
  Groupflow31bd02c9B2524a61Aa6a47232a79af85,
  LogoTypeA96c992b923040a794dcAa427d859c82,
  NavMenuSlug1c4a219fD9de4421A2abF7c3699452db,
  ContentSlugDbe1e13a4f024768B2cdD83edfcf8b0d
}

export default Components;